export const API_URL = 'https://wipe-splash-back.onrender.com'
